import React from 'react';

import { Tag, TagProps } from '@eluve/components';
import { formatAppointmentTagLabel } from '@eluve/utils';

export type AppointmentTagData = {
  id: string;
  tag: string;
  isSystemTag: boolean | null;
};

type AppointmentTagProps = Omit<TagProps, 'color' | 'label' | 'pill'> & {
  tag: AppointmentTagData;
};

export const AppointmentTag: React.FC<AppointmentTagProps> = ({
  tag,
  ...tagProps
}) => {
  const isSystem = tag.isSystemTag ?? false;
  return (
    <Tag
      {...tagProps}
      color={isSystem ? 'orange' : 'teal'}
      label={formatAppointmentTagLabel(tag.tag)}
      pill
    />
  );
};
